var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendChallenge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6C3 4.06562 4.56562 2.5 6.5 2.5C8.43437 2.5 10 4.06562 10 6C10 7.93437 8.43437 9.5 6.5 9.5C4.56562 9.5 3 7.93437 3 6ZM1 16.5C1 13.4625 3.4625 11 6.5 11C9.5375 11 12 13.4625 12 16.5V16.6875C12 17.4125 11.4125 18 10.6875 18H2.3125C1.5875 18 1 17.4125 1 16.6875V16.5ZM14.5 4C16.1562 4 17.5 5.34375 17.5 7C17.5 8.65625 16.1562 10 14.5 10C12.8438 10 11.5 8.65625 11.5 7C11.5 5.34375 12.8438 4 14.5 4ZM14.5 11.5C16.9844 11.5 19 13.5156 19 16V16.7C19 17.4188 18.4188 18 17.7 18H13.175C13.3813 17.6094 13.5 17.1625 13.5 16.6875V16.5C13.5 14.8906 12.9563 13.4094 12.0469 12.2281C12.7531 11.7687 13.5969 11.5 14.5 11.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendChallenge);
export default __webpack_public_path__ + "static/media/friend-challenge.1fc51231a0c8e36a36472e566bc21ff9.svg";
export { ForwardRef as ReactComponent };